import { Component, DestroyRef, ElementRef, OnInit, signal, computed, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Wallet } from '../../services/wallet';
import { OnchainStateService } from '../../services/onchain-state.service';
import { ServerService } from '../../services/server.service';
import { IdentityComponent } from '../identity/identity.component';
import { ProfileSettingsSectionsComponent } from '../profile-settings-sections/profile-settings-sections.component';
import { SettingsModalComponent } from '../settings-modal/settings-modal.component';
import { PixelCreatureComponent } from '../pixel-creature/pixel-creature.component';

@Component({
  selector: 'app-profile-dropdown',
  imports: [SettingsModalComponent, PixelCreatureComponent, IdentityComponent, ProfileSettingsSectionsComponent],
  templateUrl: './profile-dropdown.component.html',
  styleUrls: ['./profile-dropdown.component.css', './profile-dropdown.component.mobile.css'],
  host: {
    '(document:click)': 'onDocumentClick($event)',
    '(document:keydown.escape)': 'onEscapeKey()',
  },
})
export class ProfileDropdownComponent implements OnInit {

  wallet = inject(Wallet);
  onchainState = inject(OnchainStateService);
  private serverService = inject(ServerService);
  private elementRef = inject(ElementRef);
  private readonly destroyRef = inject(DestroyRef);

  linkedHandle = computed<string | null>(() =>
    this.serverService.twitterHandleFor(this.wallet.activeAddress()));

  isOpen = signal<boolean>(false);
  showSettings = signal<boolean>(false);

  // Wallet state — same source as the dropdown's own panel (profile-settings-sections),
  // so the collapsed chip and the expanded balance can't disagree.
  scaledEthBalance = computed(() => {
    const balance = this.wallet.useExternalWalletForTransactions()
      ? this.wallet.externalWalletBalance()
      : this.wallet.gameAccountBalance();
    return balance / BigInt(1e13);
  });
  isSocketConnected = signal<boolean>(false);
  isReconnecting = this.serverService.isReconnecting;

  ngOnInit() {
    this.serverService.socketConnectedEvent.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(connected => {
      this.isSocketConnected.set(connected);
    });
  }

  toggle() {
    this.isOpen.update(v => !v);
  }

  onDocumentClick(event: MouseEvent) {
    if (this.isOpen() && !this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }

  onEscapeKey() {
    if (this.isOpen()) {
      this.isOpen.set(false);
    }
  }

  openSettings() {
    this.isOpen.set(false);
    this.showSettings.set(true);
  }

  closeSettings() {
    this.showSettings.set(false);
  }
}
